export var loadDynamicScript = function (url, id, callback) {
    var existingScript = document.getElementById(id);
    if (existingScript) {
        callback === null || callback === void 0 ? void 0 : callback();
    }
    else {
        var script = document.createElement('script');
        script.src = url; // URL for the third-party library being loaded.
        script.id = id; // e.g., googleMaps or stripe
        script.async = true;
        document.head.appendChild(script);
        script.onload = function () {
            callback === null || callback === void 0 ? void 0 : callback();
        };
    }
};
